import React from 'react'
import * as _ from 'underscore'
import Color from 'onecolor'
import ChartJS from 'chart.js'
import $ from 'jquery'

class XMPChart extends React.Component {
  state = {
    // labels:[],
    // values:[],
    visflag:false,
    chartDataReceived: true,
    // intx: null
  }

  componentDidMount() {
    var self = this
    if ('IntersectionObserver' in window) {
      this.intx = new IntersectionObserver(function (entry) {
        if (entry[0].isIntersecting) {
          self.setState(({visflag}) => {
            return {
              visflag: true
            }
          })
        }
      });
      this.intx.observe(self.$el);
    } else {
      this.state.visflag = true; //optimization not supported
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.visflag === true && this.state.visflag === false) {
      this.load();
    }
  }

  load = () => {
    var self = this;
    $.getJSON('/api/bc/xmp/gaps/'+self.props.gap_id+'/chart', function(v) {
      if(v) {
        self.labels = v.data.labels;
        self.values = v.data.values;
        self.legend = v.data.legend;

        var combined = _.object(self.labels, self.values);
        _.each(_.keys(combined), function (key) {
          combined[key] = combined[key] * 1;
          try {
            var kill = false;
            _.each(JSON.parse(key), function (subkey) {
              combined[subkey] = combined[subkey] || 0;
              combined[subkey] += combined[key];
              kill = true;
            });
            if (kill) delete combined[key];
          } catch (e) {
          }
        });
        self.labels = [];
        self.values = [];

        var labels = _.keys(combined);
        labels.sort(function (a, b) {
          return a - b
        });
        _.each(labels, function (label, i) {
          self.labels[i] = self.legend[label] || label;
          self.values[i] = combined[label];
        });

        self.init();
      } else {
        self.intx.unobserve(self.$el)
        self.setState(({chartDataReceived}) => {
          return {
            chartDataReceived: false
          }
        })
      }
    });
  }

  init = () => {
    var self = this;
    if (this.props.type == 'none') return;
      var base_colors = ['#084a8e','#116eba','#47aff3','#009899','#009867','#652b8f','#cc3467'];
      var count = self.values.length;
      var colors = [];

      function round(num,dec) { return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec) };

      var mod = 3;
      _.each(_.range(mod), function() { colors.push(_.sample(_.without.apply(_, [base_colors, colors]))) });
      _.each(_.range(mod,count), function(i) {
        colors.push( Color(colors[i % mod]).lightness(round(0.4*(Math.random()-0.5),2),true).hex() );
      });

      var chart = new ChartJS.Chart(self.$el.querySelector('canvas').getContext("2d"), {
        type: self.props.type,
        data: {
          labels: _.map(self.labels, function(label) {
            return (label.length > 32)
              ? label.replace(/\..*$/, '').length<48 ? label.replace(/\..*$/, '')
                : label.substr(0, 48).replace(/\s+\S*$/, '') + '...'
              : label;
          }),
          datasets: [{
            data: self.values,
            backgroundColor: self.props.type=='line' ? colors[0] : colors,
            borderColor: self.props.type=='line' ? null : '#FFF',
            borderWidth: self.props.type=='line' ? 0 : 2
          }]
        },
        options: {
          legend: { display: false },
          responsive: true,
          maintainAspectRatio: false
        },
      });
  }

  render() {
    const { gap_id, type } = this.props;
    return(
      <div ref={(container) => this.$el = container} className={this.state.chartDataReceived ? 'xmp-reward-container' : ''}>
      {(this.state.chartDataReceived) ?
        (
        <div className="xmp-chart-container">
          <canvas></canvas>
        </div>) : null
      }
      </div>
    )
  }
}

export default XMPChart



// WEBPACK FOOTER //
// ./src/components/XMPChart.js